"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeDeliveryDayPreview = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const andes_react_1 = require("@yonderland/andes-react");
const react_i18next_1 = require("react-i18next");
const i18nConstants_1 = require("../../../../constants/i18nConstants");
const CheckoutDeliveryContext_1 = require("../../../../context/CheckoutDeliveryContext");
const common_queries_1 = require("@as-react/common-queries");
const common_components_1 = require("@as-react/common-components");
const react_query_1 = require("@tanstack/react-query");
const BuyFormUtil_1 = require("../../../../util/BuyFormUtil");
const react_1 = require("react");
const BasketUtil_1 = tslib_1.__importDefault(require("../../../../util/BasketUtil"));
const axios_1 = require("axios");
const DeliveryPreselectedCardView_1 = require("../DeliveryPreselectedCardView");
const DateUtil_1 = require("../../../../util/DateUtil");
const DeliveryDateLabel = ({ date, locale, customWeekday }) => {
    const { weekday, day, month } = (0, DateUtil_1.formatTimeStampToDateParts)(date, locale, {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
    });
    return ((0, jsx_runtime_1.jsxs)(andes_react_1.TextAlpha, { strong: true, children: [customWeekday || weekday, " ", `${day} ${month}`] }));
};
const HomeDeliveryDayPreview = () => {
    const { t } = (0, react_i18next_1.useTranslation)(i18nConstants_1.I18N_NAMESPACES.checkout);
    const { defaultRequestParams, servicesEndpoint, root, locale } = (0, common_components_1.useAemConfig)();
    const [{ info, activeDeliveryOption }, dispatch] = (0, CheckoutDeliveryContext_1.useDeliveryState)();
    const { getNamedDayDeliveryDates } = (0, common_queries_1.checkoutQueries)({ servicesEndpoint, defaultRequestParams });
    const { data: deliveryDates, error: deliveryDatesError } = (0, react_query_1.useQuery)(getNamedDayDeliveryDates({
        enabled: (0, BuyFormUtil_1.showNamedDays)(activeDeliveryOption),
    }));
    (0, react_1.useEffect)(() => {
        if ((0, axios_1.isAxiosError)(deliveryDatesError)) {
            if (BasketUtil_1.default.isBasketNotFound(deliveryDatesError) || BasketUtil_1.default.isBasketNotInitialized(deliveryDatesError)) {
                location.href = `${root}checkout/basket-overview.html`;
            }
        }
    }, [deliveryDatesError]);
    if (!deliveryDates) {
        return null;
    }
    const deliveryDate = deliveryDates.find(date => { var _a; return date.date.toString() === ((_a = info.deliveryDate) === null || _a === void 0 ? void 0 : _a.toString()); });
    const getDeliveryDateLabel = (date) => (0, DateUtil_1.isTomorrow)(date.date) ? ((0, jsx_runtime_1.jsx)(DeliveryDateLabel, { date: date.date, locale: locale, customWeekday: t('checkout.delivery.delivery.day.tomorrow') })) : (date.label);
    const handleEditDeliveryDay = () => {
        dispatch({ type: 'set_open_selector', payload: 'delivery-day' });
    };
    const getHeaderContent = () => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(andes_react_1.TextAlpha, { variant: "bodyS", children: t('checkout.delivery.delivery.day.title') }), (0, jsx_runtime_1.jsx)(andes_react_1.TextAlpha, { strong: true, children: getDeliveryDateLabel(deliveryDate ? deliveryDate : deliveryDates[0]) })] }));
    return ((0, jsx_runtime_1.jsx)(DeliveryPreselectedCardView_1.DeliveryPreselectedCardView, { testId: "hd_date_card", header: getHeaderContent(), onEdit: handleEditDeliveryDay }));
};
exports.HomeDeliveryDayPreview = HomeDeliveryDayPreview;
